import { useEffect } from 'react';
import posthog from 'posthog-js';
import { useAuth } from '@/contexts/AuthContext';

const KEY = import.meta.env.VITE_POSTHOG_KEY;
const HOST = import.meta.env.VITE_POSTHOG_HOST;

let initialized = false;

export function PostHogTracker() {
    const { isAuthenticated, isLoading } = useAuth();

    useEffect(() => {
        if (!import.meta.env.PROD || !KEY || isLoading) return;

        if (isAuthenticated) {
            if (initialized) {
                // Closes the marketing→app funnel while still anonymous,
                // then we go dark for the rest of the authed session.
                posthog.capture('user_authenticated');
                posthog.reset();
                posthog.opt_out_capturing();
            }
            return;
        }

        if (!initialized) {
            posthog.init(KEY, {
                api_host: HOST,
                defaults: '2026-01-30',
                person_profiles: 'always',
                capture_exceptions: true,
                session_recording: {
                    maskAllInputs: true,
                    maskTextSelector: '[data-ph-mask]',
                },
            });
            initialized = true;
        } else {
            posthog.opt_in_capturing();
        }
    }, [isAuthenticated, isLoading]);

    return null;
}

export function trackAnonymous(event: string, properties?: Record<string, unknown>): void {
    if (!import.meta.env.PROD || !initialized) return;
    posthog.capture(event, properties);
}
